import { get, post, put } from './api_helper'
import { notifications } from './notifications'
import { messageFormartError } from './utilsMessageErrors'

import { apiProductoPropioBloqueo, apiProveedorBloqueo } from '@/common/constants/api'
import { IAsignacionProveedorActividad } from '@/common/interfaces/asignacionProveedorActividad'
import { IBoletoBarcos, ISendBloqueoData } from '@/common/interfaces/bloqueos'
import { PathEstado } from '@/common/interfaces/general'
import { AsignacionProveedorActividadSend } from '@/common/interfaces/sends'

// GETS ============================================================================================
export const getProveedorBloqueo = (): Promise<any> => {
  return get(apiProveedorBloqueo)
}

export const getProductoPropioBloqueo = (): Promise<any> => {
  return get(apiProductoPropioBloqueo)
}

export const getGeografia = async (): Promise<any> => {
  return get(`Geografias?$filter=EsBase eq true`)
}

export const getEspecialidadProveedor = async (): Promise<any> => {
  return get(
    `ListasSeleccion?$select=ListaSeleccionId,Nombre&$filter=Ambito eq 'Proveedor.Especialidad.Experiencia' or Ambito eq 'Proveedor.Especialidad.Experiencia.GPS'`,
  )
}

export const getListaSeleccionByAmbito = async (ambito: string): Promise<any> => {
  return get(`ListasSeleccion?$filter=Ambito eq '${ambito}'`)
}

export const getOrdenesTrabjo = async (url: string): Promise<any> => {
  return get(url)
}

export const buscarOrdenesTrabajo = async (data: object): Promise<any> => {
  return post('OrdenesTrabajoBusiness/Buscar', data)
}

export const buscarAsignacionesGpsPendientes = async (data: object): Promise<any> => {
  return post('OrdenesTrabajoBusiness/BuscarAsignacionesGpsPendientes', data)
}

export const getSalidaEmbarcaciones = async (url: string): Promise<any> => {
  return get(url)
}

export const getBussiness = (url: string): Promise<any> => {
  return get(url).then((res) => {
    return res
  })
}

export const getOrdenesPago = async (url: string): Promise<any> => {
  return get(url)
}

export const getData = async (url: string): Promise<any> => {
  return get(url).catch((error) => {
    notifications({
      title: `Falló al obtener los datos de ${url}`,
      message: messageFormartError(error),
      toastType: 'error',
    })
  })
}

export const getDocumentosProveedorById = async (proveedorId: number): Promise<any> => {
  return get(`DocumentosCursosProveedor?$filter=ProveedorId eq ${proveedorId} &$expand=Tipo,Proveedor,DocumentosCursos`)
    .then((resp) => resp.value)
    .catch((error) => {
      notifications({
        title: 'Error',
        message: messageFormartError(error),
        toastType: 'error',
      })

      return []
    })
}

export const getAllListaSeleccion = async (): Promise<any> => {
  // `$filter`, junto y con el prefijo. Escrito como `filter = ` el parámetro se llamaba
  // literalmente `"filter "` —con el espacio incluido— así que OData lo descartaba y el catálogo
  // global llegaba SIN filtrar: todo combo alimentado por él ofrecía también los ítems de ámbito
  // `Productos.Feature`. Confirmado en UAT, la petición salía como
  // `ListasSeleccion?filter%20=%20Ambito%20ne%20...`.
  return get(`ListasSeleccion?$filter=Ambito ne 'Productos.Feature'`)
}

export const getEstados = async (): Promise<any> => {
  return get(`Estados`)
}

export const getReservasWizzard = (estados: any): Map<string, PathEstado> => {
  if (estados['Reserva'] === undefined) {
    return new Map<string, PathEstado>()
  }
  const reservaPathForEstado = new Map<string, PathEstado>()

  reservaPathForEstado.set('actividades', {
    name: 'Actividades',
    estadosId: [],
    siglas: 'A',
    to: 'actividades',
    color: 'RGB( 135, 206, 250)',
    colorInactivo: 'RGB(175, 246, 255)',
    contador: 'reservasBloqueadas',
  })
  reservaPathForEstado.set('pendiente', {
    name: 'Reserva Pendiente',
    estadosId: [
      estados['Reserva']['Reserva Pendiente'].EstadoId,
      estados['Reserva']['Modificación Pendiente'].EstadoId,
    ],
    siglas: 'RP',
    to: 'pendiente',
    color: 'RGB(204, 178, 0)',
    colorInactivo: 'RGB(204, 204, 32)',
    contador: 'pendientes',
  })
  reservaPathForEstado.set('cancelacionPendiente', {
    name: 'Cancelación Pendiente',
    estadosId: [estados['Reserva']['Cancelación Pendiente'].EstadoId],
    siglas: 'CP',
    to: 'cancelacionPendiente',
    color: 'RGB(255, 165, 0)',
    colorInactivo: 'RGB(255, 205, 40)',
    contador: 'cancelaciones',
  })
  reservaPathForEstado.set('reservado', {
    name: 'Reservado',
    estadosId: [estados['Reserva']['Reservado'].EstadoId],
    siglas: 'R',
    to: 'reservado',
    color: 'RGB(60, 179, 113)',
    colorInactivo: 'RGB(100, 219, 153)',
  })
  reservaPathForEstado.set('cancelado', {
    name: 'Cancelado',
    estadosId: [estados['Reserva']['Cancelado'].EstadoId],
    siglas: 'C',
    to: 'cancelado',
    color: 'RGB( 255, 99, 71)',
    colorInactivo: 'RGB(255, 139, 111)',
  })
  reservaPathForEstado.set('negado', {
    name: 'Negado',
    estadosId: [estados['Reserva']['Negado'].EstadoId],
    siglas: 'N',
    to: 'negado',
    color: 'RGB( 128, 0, 32)',
    colorInactivo: 'RGB(168, 40, 72)',
  })

  return reservaPathForEstado
}

export const getBookingReservas = async (): Promise<any> => {
  return get(`Bookings?$select=BookingId,BookingCode`)
    .then((resp) => resp)
    .catch((error) => {
      notifications({ ex: error })
    })
}

export const getProveedoresReservas = async (): Promise<any> => {
  return get(`Proveedores?$select=ProveedorId,NombreCompleto&$filter=Estado`)
    .then((resp) => resp)
    .catch((error) => {
      notifications({ ex: error })
    })
}

// POSTS
export const postAsignacionesProveedorActividades = async (data: IAsignacionProveedorActividad): Promise<any> => {
  return post(`AsignacionesProveedorActividades`, data)
}

export const addNewAttach = async (data: any): Promise<any> => {
  try {
    const response = await post('MatrizAsignacionBusiness/Atar', data)

    notifications({
      title: `Atado Guardado`,
      message: 'Se ingresó correctamente',
    })

    return response
  } catch (error) {
    notifications({
      title: 'Error',
      message: messageFormartError(error),
      toastType: 'error',
    })
    throw error
  }
}

export const generarBloqueos = async (url: string, data: any): Promise<any> => {
  return post(url, data)
}

// PUT
export const putBoletosEmbarcaciones = async (url: string, dataItem: IBoletoBarcos): Promise<any> => {
  const {
    BloqueoBoletoId,
    VueloIdaId,
    VueloRetornoId,
    EmbarcacionId,
    ProveedorId,
    EstadoId,
    FechaIda,
    FechaRetorno,
    CantidadOperativa,
    CantidadBloqueoTreintaDias,
    CantidadDevueltaTreintaDias,
    CantidadPrimeraEmision,
    CantidadBloqueoDiecisieteDias,
    CantidadDevueltaDiecisieteDias,
    CantidadUltimaHora,
    CantidadTotalEmitidos,
    CantidadDevueltaSieteDias,
    CantidadUsadosBloqueo,
    CantidadFueraBloqueo,
    SaldoBloqueo,
    CantidadTotalDevueltos,
    ConcresionAnual,
    ConcresionMensual,
    Comentario,
    Eliminado,
    SalidaEmbarcacionId,
    ComentarioPrimeraEmision,
    ComentarioUltimaHora,
  }: ISendBloqueoData = dataItem
  const dataSend: ISendBloqueoData = {
    BloqueoBoletoId,
    CantidadBloqueoDiecisieteDias,
    CantidadBloqueoTreintaDias,
    CantidadDevueltaDiecisieteDias,
    CantidadDevueltaSieteDias,
    CantidadDevueltaTreintaDias,
    CantidadFueraBloqueo,
    CantidadOperativa,
    CantidadPrimeraEmision,
    CantidadTotalDevueltos,
    CantidadTotalEmitidos,
    CantidadUltimaHora,
    CantidadUsadosBloqueo,
    Comentario,
    ConcresionAnual,
    ConcresionMensual,
    Eliminado,
    EmbarcacionId,
    EstadoId,
    FechaIda,
    FechaRetorno,
    ProveedorId,
    SaldoBloqueo,
    SalidaEmbarcacionId,
    VueloIdaId,
    VueloRetornoId,
    ComentarioPrimeraEmision,
    ComentarioUltimaHora,
  }

  return put(`${url}(${dataItem.BloqueoBoletoId})`, dataSend)
    .then(() => {
      notifications({
        message: 'El registro se actualizó',
        title: 'Éxito',
        toastType: 'success',
      })
    })
    .catch((error) => {
      notifications({ ex: error })
    })
}

export const putBoletosHoteles = async (url: string, dataItem: any): Promise<any> => {
  const dataSend = { ...dataItem }

  delete dataSend.inEdit
  delete dataSend.selected

  return put(`${url}(${dataSend.BloqueoBoletoHotelId})`, dataSend)
    .then(() => {
      notifications({
        message: 'El registro se actualizó',
        title: 'Éxito',
        toastType: 'success',
      })
    })
    .catch((error) => {
      notifications({ ex: error })
    })
}

export const putAsignacionActividadProveedor = async (
  url: string,
  dataSend: AsignacionProveedorActividadSend,
  tipo: string,
): Promise<any> => {
  // Avisa del fallo y ademas lo PROPAGA. Antes solo avisaba y la promesa resolvia igual, asi que
  // quien llamaba no podia distinguir exito de error: la matriz pintaba el cambio de rol aunque el
  // backend lo hubiera rechazado, y solo se descubria al recargar.
  return put(`${url}(${dataSend.AsignacionProveedorActividadId})`, dataSend)
    .then(() => {
      notifications({
        message: `Se asignó como ${tipo}`,
        title: 'Éxito',
        toastType: 'info',
      })
    })
    .catch((error) => {
      notifications({ ex: error })
      throw error
    })
}
